// --- Fix: Add debounce function (required by cart, search, etc.)
function debounce(func, wait, immediate) {
  let timeout;
  return function() {
    const context = this, args = arguments;
    const later = function() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
// --- Fix: Add ModalDialog base class (used by product-modal.js)
if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll('[data-close-modal]').forEach((button) => {
        button.addEventListener('click', this.hide.bind(this));
      });
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.hide();
      });
    }

    show(opener) {
      this.openedBy = opener;
      this.setAttribute('open', '');
      document.body.classList.add('overflow-hidden');
      this.focus();
    }

    hide() {
      this.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
      this.openedBy && this.openedBy.focus();
    }
  }

  customElements.define('modal-dialog', ModalDialog);
}

document.addEventListener('DOMContentLoaded', function () {
  const cartDrawer = document.getElementById('CartDrawer');
  const cartDrawerOverlay = document.querySelector('.cart-drawer__overlay');
  const cartDrawerClose = document.querySelector('.cart-drawer__close');
  const addToCartButtons = document.querySelectorAll('form[action^="/cart/add"]');

  function openCartDrawer() {
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeCartDrawer() {
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', closeCartDrawer);
  }

  if (cartDrawerClose) {
    cartDrawerClose.addEventListener('click', closeCartDrawer);
  }

});
